import Vue from 'vue';
import store from './store.js';
import {
    LiveSearch,
    CollectionComponent,
    ContinuousCollectionComponent,
    SyncsWithUrl,
    ResetsPage,
} from 'clockvine-vue';

const app = new Vue({
    el: 'main',
    store,

    data: {
        params: {
            page: 1,
            search: '',
            type: null,
        },
    },

    computed: {
        nextPage() {
            const urlParams = new URLSearchParams(location.search);
            urlParams.set('page', this.params.page + 1);
            return '?' + urlParams.toString();
        },

    },

    methods: {
        filterTopic(event) {
            // takes the current url, and updates the type param to the given value
            const url = new URL(window.location.href);
            if (event.target.value === 'null') { 
                url.searchParams.delete('type');
            } else {
                url.searchParams.set('type', event.target.value);
            }
            window.location.href = url.toString();
        }
    },

    mixins: [
        new SyncsWithUrl('params', {
            page: () => false,
            orderBy: 'title asc',
        }),
        new ResetsPage(),
    ],

    components: {
        resources: ContinuousCollectionComponent.for('resources'),
        resourceTypes: CollectionComponent.for('resourceTypes'),
        search: LiveSearch,
    },
});
